import type { SVGProps } from 'react'

/** Minimal "image / media" mark used by `<MediaPlaceholder>`. */
export function PlaceholderIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="m3 16 5-5 4 4 3-3 6 6" />
      <circle cx="8" cy="9" r="1.25" fill="currentColor" />
    </svg>
  )
}
